import 'react-phone-number-input/style.css'

import classNames from 'classnames'
import parsePhoneNumberFromString, { CountryCode } from 'libphonenumber-js'
import { FC, memo } from 'react'
import PhoneInput from 'react-phone-number-input'
import type { PhoneNumberFieldProps } from './phone-number-field.interface'
import classes from './phone-number-field.module.scss'

export const PhoneNumberField: FC<PhoneNumberFieldProps> = memo(
  ({ error, inputClass, buttonClass, defaultCountry, value, placeholder, onChange, onEnterKeyPress, ...props }) => {
    defaultCountry = defaultCountry?.toUpperCase() ?? 'US'

    function handleChange(value?: string) {
      const countryCode = getCountryCode(value)
      onChange?.(value ?? '', countryCode)
    }

    function handleKeyDown(event: React.KeyboardEvent<HTMLInputElement>) {
      if (event.key === 'Enter') {
        onEnterKeyPress?.(event)
      }
    }

    return (
      <PhoneInput
        className={classNames(classes.wrapper, {
          [classes.error]: error,
          [classes.disabled]: props.disabled,
          [classes.small]: props.size === 'small',
          [classes.suggestion]: props.mode === 'suggestion',
        })}
        defaultCountry={defaultCountry as CountryCode}
        value={value ?? ''}
        international={false}
        placeholder={placeholder || 'Phone number'}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        {...props}
      />
    )
  },
)

function getCountryCode(phoneNumber: string | null | undefined): string | null {
  if (!phoneNumber) return null
  const normalized = phoneNumber.startsWith('+') ? phoneNumber : `+${phoneNumber}`
  const parsed = parsePhoneNumberFromString(normalized)
  return parsed?.country ?? null
}

PhoneNumberField.displayName = 'PhoneNumberField'
